import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import CommonPage from '@/components/CommonPage';
import CommonPageOld from '@/components/CommonPageOld';
import CommonPostDetail from '@/components/CommonPostDetail';
import DiscussionAddForm from '@/components/DiscussionAddForm';
import AttachmentAddForm from '@/components/AttachmentAddForm';
import AddEditMenu from '@/components/AddEditMenu';
import EventAddForm from '@/components/EventAddForm';
//import UserList from '@/components/UserList';
import AddCalendarKey from '@/components/AddCalendarKey';
import AddAttachmentGroup from '@/components/AddAttachmentGroup';
import ListCalendarKey from '@/components/ListCalendarKey';
import ListAttachmentGroup from '@/components/ListAttachmentGroup';

import UserList from '@/components/backend/user/ListUser';
import ChangeProfile from '@/components/backend/user/ChangeProfile';
import AddUpdateUsers from '@/components/backend/user/AddUpdateUsers';
import HRDragView from '@/components/backend/user/HRDragView';
import GlobalSearchView from '@/components/GlobalSearchView';

import ListROReversalRequest from '@/components/Forms/ROReversalRequest/ListROReversalRequest';
import AddUpdateROReversalRequest from '@/components/Forms/ROReversalRequest/AddUpdateROReversalRequest';

import ListTechTime from '@/components/Forms/TechTimeMaster/ListTechTime';
import AddUpdateTechTime from '@/components/Forms/TechTimeMaster/AddUpdateTechTime';
import RecentActivity from '@/components/RecentActivity';

import ListDayforaceTimeEditRequest from '@/components/Forms/DayforaceTimeEditRequest/ListDayforaceTimeEditRequest';
import AddUpdateDayforaceTimeEditRequest from '@/components/Forms/DayforaceTimeEditRequest/AddUpdateDayforaceTimeEditRequest';

import ListPARRequest from '@/components/Forms/PARRequest/ListPARRequest';
import AddUpdatePARRequest from '@/components/Forms/PARRequest/AddUpdatePARRequest';
import ViewPARRequest from '@/components/Forms/PARRequest/ViewPARRequest';

import ListFormEmailManager from '@/components/Forms/FormEmailManager/ListFormEmailManager';
import AddUpdateFormEmailManager from '@/components/Forms/FormEmailManager/AddUpdateFormEmailManager';

import ListVendor from '@/components/Forms/VendorMaster/ListVendor';
import AddUpdateVendor from '@/components/Forms/VendorMaster/AddUpdateVendor';

import ListOfficeSupplier from '@/components/Forms/OfficeSupplier/ListOfficeSupplier';
import AddUpdateOfficeSupplier from '@/components/Forms/OfficeSupplier/AddUpdateOfficeSupplier';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/recentactivity',
            name: 'RecentActivity',
            component: RecentActivity
        },
        {
            path: '/globalsearch/:searchText',
            name: 'GlobalSearchView',
            component: GlobalSearchView,
            props: true
        },
        {
            path: '/user/list',
            name: 'UserList',
            component: UserList,
        },
        {
            path: '/changeprofile',
            name: 'ChangeProfile',
            component: ChangeProfile,
        },
        {
            path: '/updateusers/:id',
            name: 'AddUpdateUsers',
            component: AddUpdateUsers,
        },
        {
            path: '/roreversal/list',
            name: 'ListROReversalRequest',
            component: ListROReversalRequest,
        },
        {
            path: '/roreversal/add',
            name: 'AddUpdateROReversalRequest',
            component: AddUpdateROReversalRequest,
        },
        {
            path: '/roreversal/edit/:id',
            name: 'UpdateROReversalRequest',
            component: AddUpdateROReversalRequest,
        },
        {
            path: '/techtime/list',
            name: 'ListTechTime',
            component: ListTechTime,
        },
        {
            path: '/techtime/add',
            name: 'AddUpdateTechTime',
            component: AddUpdateTechTime,
        },
        {
            path: '/dayforace/time/list',
            name: 'ListDayforaceTimeEditRequest',
            component: ListDayforaceTimeEditRequest,
        },
        {
            path: '/dayforace/time/add',
            name: 'AddUpdateDayforaceTimeEditRequest',
            component: AddUpdateDayforaceTimeEditRequest,
        },
        {
            path: '/par/request/list',
            name: 'ListPARRequest',
            component: ListPARRequest,
        },
        {
            path: '/par/request/add',
            name: 'AddUpdatePARRequest',
            component: AddUpdatePARRequest,
        },
        {
            path: '/par/request/edit/:id',
            name: 'UpdatePARRequest',
            component: AddUpdatePARRequest,
        },
        {
            path: '/par/request/view/:id',
            name: 'ViewPARRequest',
            component: ViewPARRequest,
        },
        {
            path: '/form/email/manager/list',
            name: 'ListFormEmailManager',
            component: ListFormEmailManager,
        },
        {
            path: '/form/email/manager/add',
            name: 'AddUpdateFormEmailManager',
            component: AddUpdateFormEmailManager,
        },
        {
            path: '/form/email/manager/edit/:id',
            name: 'UpdateFormEmailManager',
            component: AddUpdateFormEmailManager,
        },
        {
            path: '/vendor/item/list',
            name: 'ListVendor',
            component: ListVendor,
        },
        {
            path: '/vendor/item/add',
            name: 'AddUpdateVendor',
            component: AddUpdateVendor,
        },
        {
            path: '/vendor/item/edit/:id',
            name: 'UpdateVendor',
            component: AddUpdateVendor,
        },
        {
            path: '/office/supplier/list',
            name: 'ListOfficeSupplier',
            component: ListOfficeSupplier,
        },
        {
            path: '/office/supplier/add',
            name: 'AddUpdateOfficeSupplier',
            component: AddUpdateOfficeSupplier,
        },
        {
            path: '/office/supplier/edit/:id',
            name: 'UpdateOfficeSupplier',
            component: AddUpdateOfficeSupplier,
        },
        {
            path: '/hrdragview',
            name: 'HRDragView',
            component: HRDragView,
        },
        {
            path: '/:type',
            name: 'CommonPage',
            component: CommonPage
        },{
            path: '/:type/test',
            name: 'CommonPageOld',
            component: CommonPageOld
        },
        {
            path: '/:type/view',
            name: 'CommonPostDetail',
            component: CommonPostDetail
        },
        {
            path: '/:type/add_post',
            name: 'DiscussionAddForm',
            component: DiscussionAddForm
        },
        {
            path: '/:type/edit_post/:id',
            name: 'DiscussionEditForm',
            component: DiscussionAddForm
        },
        {
            path: '/:type/add_document',
            name: 'AttachmentAddForm',
            component: AttachmentAddForm
        },
        {
            path: '/:type/edit_document/:id',
            name: 'AttachmentEditForm',
            component: AttachmentAddForm
        },
        {
            path: '/:type/add_date',
            name: 'EventAddForm',
            component: EventAddForm
        },
        {
            path: '/:type/edit_date/:id',
            name: 'EventEditForm',
            component: EventAddForm
        },
        {
            path: '/menu/add-edit-menu',
            name: 'AddEditMenu',
            component: AddEditMenu
        },
        /*{
            path: '/user/list',
            name: 'UserList',
            component: UserList
        },*/
        {
            path: '/key/list',
            name: 'ListCalendarKey',
            component: ListCalendarKey
        },
        {
            path: '/key/add',
            name: 'AddCalendarKey',
            component: AddCalendarKey
        },
        {
            path: '/key/edit/:id',
            name: 'EditCalendarKey',
            component: AddCalendarKey
        },
        {
            path: '/attachment-group/list',
            name: 'ListAttachmentGroup',
            component: ListAttachmentGroup
        },
        {
            path: '/attachment-group/add',
            name: 'AddAttachmentGroup',
            component: AddAttachmentGroup
        },
        {
            path: '/attachment-group/edit/:id',
            name: 'EditAttachmentGroup',
            component: AddAttachmentGroup
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js